import React, { useEffect, useState } from "react"
import "./AddCourse.scss"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  Spinner,
} from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import Country from "../../../utils/Data/Country"
import * as Yup from "yup"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { Calendar } from "primereact/calendar"
import { InputNumber } from "primereact/inputnumber"
import { useNavigate } from "react-router-dom"
import CourseApi from "Api/CourseApi"
import UniversityApi from "Api/UniversityApi"
import programApi from "Api/programApi"
import { toast } from 'react-toastify'
import { ToastContainer } from 'react-toastify'

const AddCourse = () => {
  document.title = "Add Course"
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate("")
  const accessToken = localStorage.getItem("accessToken")
  const CourseInitialData = {
    courseName: "",
    duration: "",
    Program: "",
    level: "",
    eligibilityCriteria: "",
    totalSeats: "",
    tuitionFee: "",
    admissionFee: "",
    intakeYear: "",
    modeOfStudy: "",
    description: "",
    university: "",
    institution: "",
  }

  const [courseData, setCourseData] = useState(CourseInitialData)

  const [errors, setErrors] = useState({})
  const handleCourseDataChange = (name, value) => {
    setCourseData({ ...courseData, [name]: value })
    setErrors({ ...errors, [name]: "" })
  }

  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "Course", link: "#" },
    { label: "Add Course", link: "#" },
  ]
  const typeOptions = [
    { name: "underGraduate", code: "underGraduate" },
    { name: "postGraduate", code: "postGraduate" },
  ]
  const approvalOptions = [
    { name: "Yes", code: "Yes" },
    { name: "No", code: "No" },
  ]
  const modeofStudyOptions = [
    { name: "Online", code: "Online" },
    { name: "Offline", code: "Offline" },
    { name: "Hybrid", code: "Hybrid" },
  ]
  const [uniMenu, setUniMenu] = useState([])
  const universityDropDown = () => {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    UniversityApi.getUniversityMenuList(config)
      .then(res => {
        setUniMenu(res.data.university)
      })
      .catch(error => {
        console.log(error)
      })
  }
  useEffect(() => {
    universityDropDown()
  }, [accessToken])
  const [programMenu, setProgramMenu] = useState([])

  const programList = programMenu.map(program => ({
    name: program.programName,
    code: program._id,
  }))

  const getProgramMenuList = institutionCode => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
    programApi
      .getProgramByInstitue(institutionCode, config)
      .then(res => {
        if (res.data.status) {
          setProgramMenu(res.data.program)
        }
      })
      .catch(error => {
        console.log(error)
      })
  }

  const [instituteMenu, setInstituteMenu] = useState([])
  const fetchInstituteByUniId = universityCode => {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }
    UniversityApi.getCollegesByUniversity(universityCode, config)
      .then(res => {
        setInstituteMenu(res.data.colleges)
      })
      .catch(error => {
        console.log(error)
      })
  }

  const ValidateCourse = Yup.object().shape({
    courseName: Yup.string().required(" Program name is required "),
    duration: Yup.string().required("Duration is required"),
    level: Yup.string().required("Level is required"),
    eligibilityCriteria: Yup.string().required(
      "Eligibility criteria is required",
    ),
    totalSeats: Yup.date()
      .typeError("Invalid Total Seats")
      .required("Total seats are required"),
    tuitionFee: Yup.date()
      .typeError("Invalid Tution Fee")
      .required("Tution fee is required"),
    admissionFee: Yup.string().required("Admission fee is required"),
    intakeYear: Yup.number()
      .typeError("Invalid Year")
      .min(1900, "Year cannot be less than 1900")
      .max(new Date().getFullYear(), "Year cannot be in the future")
      .required("Intake Year fee is required"),
    modeOfStudy: Yup.string()
      .oneOf(["online", "offline", "hybrid"], "Invalid Mode of Study")
      .required("Mode of study  is required"),
    description: Yup.string().required("Description is required"),
    university: Yup.string().required("University is required"),
    institution: Yup.string().required("Institution is required"),
  })

  const addCourse = () => {
    const payload = {
      ...courseData,
      university: courseData?.university?._id,
      institution: courseData?.institution?._id,
      Program: courseData?.Program?.code,
      modeOfStudy: courseData?.modeOfStudy?.name?.toLowerCase(),
    }

    console.log(payload)

    setLoading(true)

    ValidateCourse.validate(payload, { abortEarly: false })
      .then(() => {
        const config = {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
        CourseApi.addCourse(payload, config)
          .then(res => {
            if (res.data.status) {
              setLoading(false)
              setTimeout(() => {
                navigate("/courselist")
              }, 1000)
              toast.success(res.data.message)
             
            }
          })
          .catch(error => {
            setLoading(false)
            console.log(error)
            toast.error(error.response.data.message)
          })
      })
      .catch(err => {
        setLoading(false)
        const validationErrors = {}
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message
        })
        setErrors(validationErrors)
      })
  }

  return (
    <div className="add-course">
      <ToastContainer />
      <Row>
        <Col xs="12">
          <div className="course-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb data={breadcrumbItems} pageTitle="Add Course" />
          </div>

          <Card className="mt-4 ">
            <CardBody>
              <div className="course-add-form ">
                <div className="course-add-inp">
                  <label htmlFor="university">University</label>

                  <div className="inp-err">
                    <Dropdown
                      value={courseData.university}
                      onChange={e => {
                        handleCourseDataChange("university", e.value)
                        fetchInstituteByUniId(e.value.universityCode)
                      }}
                      options={uniMenu}
                      optionLabel="universityName"
                      placeholder="Select University"
                      filter
                    />
                    {errors.university && (
                      <small className="error">{errors.university}</small>
                    )}
                  </div>
                </div>

                <div className="course-add-inp">
                  <label
                    htmlFor="
                                    Institution"
                  >
                    Institution
                  </label>

                  <div className="inp-err">
                    <Dropdown
                      value={courseData.institution}
                      onChange={e => {
                        handleCourseDataChange("institution", e.value)
                        getProgramMenuList(e.value.institutionCode)
                      }}
                      options={instituteMenu}
                      optionLabel="institutionName"
                      placeholder="Select Institution"
                      filter
                    />
                    {errors.Institution && (
                      <small className="error">{errors.Institution}</small>
                    )}
                  </div>
                </div>
                <div className="course-add-inp">
                  <label htmlFor="CourseName">Program Name</label>
                  <div className="inp-err">
                    <Dropdown
                      id="courseName"
                      value={courseData.Program}
                      onChange={e => handleCourseDataChange("Program", e.value)}
                      options={programList}
                      optionLabel="name"
                      placeholder="Choose Prorgam"
                      filter
                    />

                    {errors.Program && (
                      <small className="error">{errors.Program}</small>
                    )}
                  </div>
                </div>

                <div className="course-add-inp">
                  <label htmlFor="courseName" className="label">
                    Course Name
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="courseName"
                      value={courseData.courseName}
                      onChange={e =>
                        handleCourseDataChange("courseName", e.target.value)
                      }
                      placeholder="Enter Course Name"
                      className="inp-field-box"
                    />
                    {errors.courseName && (
                      <small className="error">{errors.courseName}</small>
                    )}
                  </div>
                </div>

                <div className="course-add-inp">
                  <label htmlFor="duration" className="label">
                    Duration
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="duration"
                      value={courseData.duration}
                      onChange={e =>
                        handleCourseDataChange("duration", e.target.value)
                      }
                      placeholder="Enter Duration"
                      className="inp-field-box"
                    />
                    {errors.duration && (
                      <small className="error">{errors.duration}</small>
                    )}
                  </div>
                </div>

                <div className="course-add-inp">
                  <label htmlFor="level" className="label">
                    Level
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="level"
                      value={courseData.level}
                      onChange={e =>
                        handleCourseDataChange("level", e.target.value)
                      }
                      placeholder="Enter Level"
                      className="inp-field-box"
                    />
                    {errors.level && (
                      <small className="error">{errors.level}</small>
                    )}
                  </div>
                </div>

                <div className="course-add-inp">
                  <label htmlFor="EligibilityCriteria" className="label">
                    EligibilityCriteria
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="eligibilityCriteria"
                      value={courseData.eligibilityCriteria}
                      onChange={e =>
                        handleCourseDataChange(
                          "eligibilityCriteria",
                          e.target.value,
                        )
                      }
                      placeholder="Enter EligibilityCriteria"
                      className="inp-field-box"
                    />
                    {errors.eligibilityCriteria && (
                      <small className="error">
                        {errors.eligibilityCriteria}
                      </small>
                    )}
                  </div>
                </div>

                <div className="course-add-inp">
                  <label htmlFor="totalSeats" className="label">
                    TotalSeats
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="totalSeats"
                      value={courseData.totalSeats}
                      onChange={e =>
                        handleCourseDataChange("totalSeats", e.target.value)
                      }
                      placeholder="Enter TotalSeats"
                      className="inp-field-box"
                    />
                    {errors.totalSeats && (
                      <small className="error">{errors.totalSeats}</small>
                    )}
                  </div>
                </div>

                <div className="course-add-inp">
                  <label htmlFor="tuitionFee" className="label">
                    TuitionFee
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="tuitionFee"
                      value={courseData.tuitionFee}
                      onChange={e =>
                        handleCourseDataChange("tuitionFee", e.target.value)
                      }
                      placeholder="Enter TuitionFee"
                      className="inp-field-box"
                    />
                    {errors.tuitionFee && (
                      <small className="error">{errors.tuitionFee}</small>
                    )}
                  </div>
                </div>

                <div className="course-add-inp">
                  <label htmlFor="admissionFee" className="label">
                    AdmissionFee
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="admissionFee"
                      value={courseData.admissionFee}
                      onChange={e =>
                        handleCourseDataChange("admissionFee", e.target.value)
                      }
                      placeholder="Enter AdmissionFee"
                      className="inp-field-box"
                    />
                    {errors.admissionFee && (
                      <small className="error">{errors.admissionFee}</small>
                    )}
                  </div>
                </div>

                <div className="course-add-inp">
                  <label htmlFor="intakeYear" className="label">
                    IntakeYear
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="intakeYear"
                      value={courseData.intakeYear}
                      onChange={e =>
                        handleCourseDataChange("intakeYear", e.target.value)
                      }
                      placeholder="Enter IntakeYear"
                      className="inp-field-box"
                    />
                    {errors.intakeYear && (
                      <small className="error">{errors.intakeYear}</small>
                    )}
                  </div>
                </div>

                <div className="course-add-inp">
                  <label htmlFor="modeOfStudy">Mode Of Study</label>
                  <div className="inp-err">
                    <Dropdown
                      id="modeOfStudy"
                      value={courseData.modeOfStudy}
                      onChange={e =>
                        handleCourseDataChange("modeOfStudy", e.value)
                      }
                      optionLabel="name"
                      options={modeofStudyOptions}
                      placeholder=" Select Mode of Study"
                    />
                    {errors.modeOfStudy && (
                      <small className="error">{errors.modeOfStudy}</small>
                    )}
                  </div>
                </div>
                <div className="course-add-inp">
                  <label htmlFor="description" className="label">
                    Description
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="description"
                      value={courseData.description}
                      onChange={e =>
                        handleCourseDataChange("description", e.target.value)
                      }
                      placeholder="Enter Description"
                      className="inp-field-box"
                    />
                    {errors.description && (
                      <small className="error">{errors.description}</small>
                    )}
                  </div>
                </div>
              </div>

              <div className="save-cancel-btn mt-4 d-flex align-items-center justify-content-end gap-3">
                <Button
                  type="button"
                  outline
                  color="danger"
                  className="waves-effect waves-light"
                  onClick={() => {
                    navigate(-1)
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  color="secondary"
                  className="waves-effect waves-light"
                  onClick={() => {
                    addCourse()
                  }}
                >
                  {loading ? <Spinner size="sm" /> : "Add"}
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default AddCourse
